<template>
    <v-layout row wrap mb-5>
    <v-flex>
      <component
        :is="fieldConfig.component"
        :label="fieldConfig.label"
        :name="fieldConfig.name"
        :validation="fieldConfig.validation"
        :value="value"
        :disabled="disabled"
        v-bind="fieldConfig.params"
      ></component>
      <v-layout justify-space-between>
        <nx-milenium-form-field-lines :field-lines="fieldLines"></nx-milenium-form-field-lines>
        <nx-milenium-form-field-linking-field
          :field="fieldConfig.name"
          :linkingField="linkingField"
          :linkableFields="linkableFields"
          :is-linked="isLinked"
          :disabled="disabled"
          v-on="$listeners"
        ></nx-milenium-form-field-linking-field>
      </v-layout>
      <v-divider></v-divider>
    </v-flex>
  </v-layout>
</template>

<script>
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import NxMileniumFormFieldLinkingField from './MileniumFormFieldLinkingField';
import NxMileniumFormFieldLines from './MileniumFormFieldLines';

export default {
  components: {
    NxMileniumFormFieldLinkingField,
    NxMileniumFormFieldLines,
  },
  props: {
    fieldConfig: {
      type: Object,
      required: true,
    },
    fieldsLines: {
      type: Object,
    },
    fieldValue: {
      type: Object,
      default: () => ({}),
    },
    masterChannelValue: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldLines() {
      return this.fieldsLines[this.fieldConfig.name] || null;
    },
    value() {
      return this.fieldValue.value || null;
    },
    linkingField() {
      return this.fieldValue.linkingField || null;
    },
    linkableFields() {
      return this.fieldValue.linkableFields || [];
    },
    isLinked() {
      if (!this.linkingField) {
        return false;
      }
      if (isEmpty(this.value) && isEmpty(this.masterChannelValue)) {
        return true;
      }
      return isEqual(this.value, this.masterChannelValue);
    },
  },
};
</script>
